// import React from "react";

// import {
//   Flex,
//   FlexItem,
// } from "@patternfly/react-core";

// import SchoolAppearanceButton from "./actions/SchoolAppearanceButton";
// import SchoolEDziennikButton from "./actions/SchoolEDziennikButton";
// import SchoolMailButton from "./actions/SchoolMailButton";
// import ProfileButton from "shared/components/ProfileButton";


// const SchoolHeaderActions = () => {
//   return (
//     <Flex
//       className="school-header-actions"
//       alignItems={{
//         default: "alignItemsCenter",
//       }}
//       spacer={{
//         default: "spacerSm",
//       }}
//       flexWrap={{
//         default: "nowrap",
//       }}
//     >
//       <FlexItem>
//         <SchoolEDziennikButton compact />
//       </FlexItem>

//       <FlexItem>
//         <SchoolMailButton compact />
//       </FlexItem>

//       <FlexItem>
//         <SchoolAppearanceButton compact />
//       </FlexItem>

//       <FlexItem>
//         <ProfileButton compact />
//       </FlexItem>
//     </Flex>
//   );
// };

// export default SchoolHeaderActions;

import React from "react";

import {
  Flex,
  FlexItem,
} from "@patternfly/react-core";

import SchoolAppearanceButton from "./actions/SchoolAppearanceButton";
import SchoolEDziennikButton from "./actions/SchoolEDziennikButton";
import SchoolMailButton from "./actions/SchoolMailButton";
import ProfileButton from "shared/components/ProfileButton";

import { useBreakpoint } from "shared/hooks/useBreakpoint";

const SchoolHeaderActions = () => {
  const { isMobile } = useBreakpoint();

  return (
    <Flex
      alignItems={{
        default: "alignItemsCenter",
      }}
      spacer={{
        default: isMobile ? "spacerXs" : "spacerSm",
      }}
      flexWrap={{
        default: "nowrap",
      }}
    >
      <FlexItem>
        <SchoolEDziennikButton compact={isMobile} />
      </FlexItem>

      <FlexItem>
        <SchoolMailButton compact={isMobile} />
      </FlexItem>

      <FlexItem>
        <SchoolAppearanceButton />
      </FlexItem>

      <FlexItem>
        <ProfileButton />
      </FlexItem>
    </Flex>
  );
};

export default SchoolHeaderActions;